import profile from '@/api/profile'

export default {
  fetchProfile ({ commit }) {
    return profile.getProfile()
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          const data = response.data.data
          commit('SET_PROFILE_DATA', data)
          return data
        }
      })
  },
  savePersonalInformation ({ commit }, payload) {
    return profile.savePersonalInformation(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          return response.data
        }
      })
  },
  saveChangePassword ({ commit }, payload) {
    return profile.saveChangePassword(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          return true
        }
      })
  }
}
